export const products = [
    {
        id: 1,
        name: "Connect Platforms and Smart Enablers",
        price: 259.00,
        description: "Staying up to date with technology and expertise while also keeping track of equipment performance and maintenance can be a time-consuming task. By connecting to our digital platforms – the Connect Platforms – we can enhance your daily operations as they provide access to our service experts, equipment information, and education insights. Customer Services Smart Enablers are top-notch technologies that expedite the delivery of our services in a highly efficient way.",
        image: "/services/connect-platforms-and-smart-enablers.png",
        amount: 1,
    },
    {
        id: 2,
        name: "Service Plans",
        price: 119.00,
        description: "Protecting your investment in medical equipment is key to sustainable business success. You can have optimal service coverage with our service plan that perfectly matches your needs. Benefit from maximized equipment performance and improved staff expertise while keeping unplanned service costs to a minimum – so you can enjoy peace of mind.",
        image: "/services/service-plans.png",
        amount: 1,
    },
    {
        id: 3,
        name: "UpLift Services",
        price: 129.00,
        description: "Medical equipment naturally goes through innovation cycles over time. If you don’t address the obsolescence of your assets, this can lead to negative return on your investment.UpLift Services keep your equipment up-to-date through upgrades and updates, giving you confidence that your equipment is current and secure. This also allows you to participate in innovations.",
        image: "/services/uplift-services.png",
        amount: 1,
    },
    {
        id: 4,
        name: "UpScale Services",
        price: 199.00,
        description: "Scarce resources can present you with a challenge when you need to strategically develop and scale the business of your service line.UpScale Services are designed to use the power of digital platforms and tap into the potential of the broader imaging community, increasing the resource base available to you and allowing you to scale your business.",
        image: "/services/upscale-services.png",
        amount: 1,
    },
    {
        id: 5,
        name: "UpSkill Services",
        price: 69.90,
        description: "An insufficient level of staff expertise and education oversight leads to delays in your procedures and inability to deliver high-quality patient care. UpSkill Services use a hybrid learning approach to provide technical and clinical knowledge. They address lifelong education and education management needs to continuously enable your workforce.",
        image: "/services/upskill-services.png",
        amount: 1,
    },
    {
        id: 6,
        name: "UpSpeed Services",
        price: 69.90,
        description: "Interruptions to your daily operations lead to inefficient staff and equipment utilization, resulting in inefficient patient flow. You don’t fullyu tilize your capabilities.UpSpeed Services provide access to support from remote technical and application experts at any time. AI-based system monitoring and proactive services further speed up your operations.",
        image: "/services/upspeed-services.png",
        amount: 1,
    },
    {
        id: 7,
        name: "UpTeam Services",
        price: 69.90,
        description: "Operational inefficiencies and workforce shortages can impact your clinical department. They lead to delays in exam schedules, and result in a negative experience for your patients.With UpTeam Services, we team up with you for operational excellence and workforce availability to boost your department’s efficiency and help you focus on your patients.",
        image: "/services/upteam-services.png",
        amount: 1,
    },
    {
        id: 8,
        name: "Uptime Services",
        price: 45.90,
        description: "You need your clinical department at the ready. Unplanned equipment downtimes result in idle time and high costs.  UpTime Services are designed to sustain your equipment quality and availability. They help you manage system downtimes, optimizing your equipment’s performance. ",
        image: "/services/uptime-services.png",
        amount: 1,
    },
]